import BpkSectionHeader from '@skyscanner-internal/backpack-web/bpk-component-section-header';

import { useMBDContext } from '../common/MBD/useMBDContext';

import Bar from './Bar';
import InfoSnippet from './InfoSnippet';

import type { BarChartItem } from './Bar';
import type { InfoSnippetItem } from './InfoSnippet';

import STYLES from './BarChartWithInfoSnippets.module.scss';

export type BarChartWithInfoSnippetsProps = {
  bars: BarChartItem[];
  description: string;
  header: string;
  snippets: InfoSnippetItem[];
  testId?: string;
};

const BarChartWithInfoSnippets = ({
  bars,
  description,
  header,
  snippets,
  testId = undefined,
}: BarChartWithInfoSnippetsProps) => {
  const { buildMBDParam, rawComponentName } = useMBDContext();

  return (
    <div
      className={STYLES.Root}
      data-testid={testId}
      data-tracking-element-id={rawComponentName}
      data-tracking-common-params={buildMBDParam(rawComponentName, {
        version: 'v1',
      })}
    >
      <div className={STYLES.Section}>
        <BpkSectionHeader title={header} description={description} />
        <div className={STYLES.Section__content}>
          <div className={STYLES.BarChart}>
            {bars.map((bar) => (
              <Bar key={bar.name} bar={bar} />
            ))}
          </div>
          <div className={STYLES.SnippetPanel}>
            <div className={STYLES.SnippetPanel__grid}>
              {snippets.map((snippet) => (
                <InfoSnippet key={snippet.label} snippet={snippet} />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BarChartWithInfoSnippets;
